module.exports = __webpack_public_path__ + "static/img/downloadIcon.4f74277.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/downloadIcon.png
// module id = o8vV
// module chunks = 0